import { names, requestSuccessFailure } from 'utilities/constants';

export const SET_CURRENT_SWIPE_CONTEXT = 'SET_CURRENT_SWIPE_CONTEXT';
export const UPLOAD_SWIPE_PREFIX = 'UPLOAD_SWIPE';
export const CLEAR_SWIPES = 'CLEAR_SWIPES';
export const STORE_SWIPE_UI_STATE = 'STORE_SWIPE_UI_STATE';
export const RESET_SWIPE_UI_STATE = 'RESET_SWIPE_UI_STATE';


const swipeConstants = {
    ...requestSuccessFailure(UPLOAD_SWIPE_PREFIX),
    ...names(SET_CURRENT_SWIPE_CONTEXT, CLEAR_SWIPES, STORE_SWIPE_UI_STATE, RESET_SWIPE_UI_STATE)
}

export default swipeConstants;